import React, { useContext } from 'react';
import { Link, useNavigate,NavLink, useLocation } from 'react-router-dom';
import logo from '../../assets/images/felixacare/ac_logo.png';
import '../../styles/header.css';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n';
import { languages } from '../../i18n';
import { LanguageContext } from '../../contexts/LanguageContext';
import { useAuth } from "../Contexts/AuthContext";
import { NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import { Modal, } from "react-bootstrap";
import axios from "axios";
// import { HiOutlineUser } from "react-icons/hi2";
import { APIURL, appLoginUrl } from "../../Global";
export const Header = () => {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  useContext(LanguageContext);
  const loc = location.pathname;
  const name = sessionStorage.getItem("name")
  const user = sessionStorage.getItem("user_type")
  const languageLabels = {
    en: 'ENGLISH',
    es: 'ESPAÑOL',
    // pt: 'PORTUGUÊS',
  };
  const { i18n: i18nextInstance } = useTranslation();
  const currentLang = i18nextInstance.language;

  const handleUserIconClick = () => {
    const isLoggedIn = auth?.isAuthenticated || !!sessionStorage.getItem('usertoken');
    if (isLoggedIn) {
      const userType = sessionStorage.getItem('user_type');
      navigate(userType ? `/${userType}` : '/');
    } else {
      navigate('/');
    }
  };

  //   const LogoutConfirmPopup = ({ show, onHide, onLogout }) => {
  //   return (
  //     <Modal
  //       show={show}
  //       onHide={onHide}
  //       size="md"
  //       aria-labelledby="contained-modal-title-vcenter"
  //       centered
  //       backdrop="static"
  //       keyboard={false}
  //     >
  //       <Modal.Body style={{ display: 'flex', flexDirection: 'column' }}>
  //         <div>
  //           <div className="alert-border">
  //             <span className="alert-icon"></span>
  //           </div>
  //         </div>
  //         <label style={{ margin: '20px auto', fontSize: '18px', color: '#4e4e4e' }}>
  //           {t('logoutConfirmMessage')}
  //         </label>
  //         <div className="form-group" style={{ display: 'flex', margin: 'auto' }}>
  //           <button
  //             type="button"
  //             className="swirl-butns"
  //             style={{ margin: '10px 4px 0px 0px', backgroundColor: '#dc3545' }}
  //             onClick={onHide}
  //           >
  //             {t('cancel')}
  //           </button>
  //           <button
  //             type="submit"
  //             className="swirl-butns"
  //             style={{ margin: '10px 0px 0px 4px', backgroundColor: '#2b69a3' }}
  //             onClick={() => {
  //               onLogout();
  //               onHide();
  //             }}
  //           >
  //             {t('confirm')}
  //           </button>
  //         </div>
  //       </Modal.Body>
  //     </Modal>
  //   );
  // };
  const callLogout = () => {
    const tokenString = sessionStorage.getItem("usertoken");
    let str = tokenString.replace(/["]+/g, "");

    axios
      .get(`${APIURL}/api/v1/account/logout/`, {
        headers: {
          Authorization: "Token " + str,
          "Content-Type": "application/json",
        },
      })

      .then((res) => {
        if (res.data.status === "success") {
          sessionStorage.removeItem("status");
          logout();

          navigate("/", { replace: true });
        } else { }
      })
      .catch((err) => { });
    navigate("/");
  };
  const handleLogout = () => {
    callLogout();
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("userid");
    sessionStorage.removeItem("usertoken");
    sessionStorage.removeItem("user_type");
    sessionStorage.removeItem("logindatas");
    sessionStorage.removeItem("verified_login");

  };


  const handleLogoutClick = () => {
    const confirmLogout = window.confirm(t('logoutConfirmMessage'));
    if (confirmLogout) {
      handleLogout();
    }
  };

  if (loc !== '/') {
    return (
      <header className="header vendor-register-header">
        <div className="header-content">
          <div className="header-logo">
            <Link to={user!==null ? `/${user}` : '/'}>
              <img src={logo} alt="Aryal Care" />
            </Link>
          </div>
          {auth.isAuthenticated && user !== 'hospital' ?
            <div style={{ display: "flex", marginLeft: "auto" }} >
                <NavLink  style={{textDecoration:"none",display:"flex",alignItems:"center",fontSize:"14px",border:"none",boxShadow:"none",padding:0,borderRight:"none",paddingRight:0,textAlign:"center",width:"fit-content",borderRadius:0,color:"#42d7c0!important"}} exact to={`/${user}`} activeClassName="active" className="inactive">
                  <i className="fas fa-home"></i>&nbsp; <b>{t('dashboard')}</b>
                </NavLink>&nbsp;&nbsp;&nbsp;
             
              <NavDropdown className="no-dropdown-arrow" style={{
                 textDecoration: 'none', display: 'flex',
                alignItems: 'center', fontSize: '12px',
                border: 'none', boxShadow: 'none',
                padding: 0, borderRight: 'none',
                paddingRight: 0, textAlign: 'center', width: 'fit-content',
                borderRadius: 0, color: '#42d7c0!important',
              }}
                title={

                  <div className="user-info" style={{ color: "" }}>
                     <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" viewBox="0 0 24 24"><g fill="none"><path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" /><path fill="#65c7c2" d="M12 2a7 7 0 0 0-7 7v3.528a1 1 0 0 1-.105.447l-1.717 3.433A1.1 1.1 0 0 0 4.162 18h15.676a1.1 1.1 0 0 0 .984-1.592l-1.716-3.433a1 1 0 0 1-.106-.447V9a7 7 0 0 0-7-7m0 19a3 3 0 0 1-2.83-2h5.66A3 3 0 0 1 12 21" /></g></svg>
                    <small className="username">{name}</small>
                    {/* <br/>
                    <small style={{color:"#777677"}} className="user-handle">@{user}</small> */}
                  </div>
                }
                id="nav-language-dropdown"
                align="end"
              >

                <NavDropdown.Item
                  onClick={handleLogoutClick}
                  className="dropdown-item"
                >
                  {t('logout')}
                </NavDropdown.Item>
              </NavDropdown>
              {/* <div  onClick={() => setLogoutConfirm(true)}                >
                  <span className="icon"> <HiOutlineUser size={20} /></span>
                  <span className="item-name">Logout</span>
                </div> */}
            </div> :
            <div style={{ marginLeft: "auto", cursor:'pointer' }} onClick={() => { loc === "/login" ? navigate("/vendor-register") : window.location.href = appLoginUrl }} className="login-newbutton">
              {loc === "/login" ? t('registerAsVendor') : t('login')}
            </div>
          }

          <NavDropdown style={{
            color: 'white', textDecoration: 'none', display: 'flex',
            alignItems: 'center',
            border: 'none', boxShadow: 'none', fontSize: '12px',
            padding: 0, borderRight: 'none',
            paddingRight: 0, textAlign: 'center', width: 'fit-content',
            borderRadius: 0
          }}
            title={

              <span style={{ color: '#01c9c9', cursor:'pointer' }}>

                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#777677" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539a7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539a7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" /></svg>&nbsp;{currentLang}
              </span>
            }
            id="nav-language-dropdown"
            align="end"
          >
            {languages.map((lng) => (
              <NavDropdown.Item
                key={lng}
                onClick={() => changeLanguage(lng)}
                active={currentLang === lng}
              >
                {languageLabels[lng]}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </div>
      </header>
    );
  }


  return (<>
    <header className="header">
      <div className="header-top-bar">
        <div className="header-container">
          <div className="top-bar-content">
            <div> <Link to="/">
                <img style={{width: "70%"}} src={logo} alt="Aryal Care" />
              </Link></div>
            <div className="top-bar-actions" style={{ fontSize: "14px", float: "right" }}>
              <div className="contact-info">
                <a href="tel:+50684150505" className="phone-link">
                  <svg xmlns="http://www.w3.org/2000/svg" className="phone-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  (+506) 84150505
                </a>

              </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {/* <a href="/find-doctor" className="find-doctor">
                <svg xmlns="http://www.w3.org/2000/svg" className="doctor-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {t('findMyDoctor')}
              </a> */}
              <a href="/vendor-register" className="register-vendor">
                {t('registerAsVendor')}
              </a>
              <NavDropdown style={{
                color: 'white', textDecoration: 'none', display: 'flex',
                alignItems: 'center', fontSize: '12px',
                border: 'none', boxShadow: 'none',
                // padding: 0,
                borderRight: 'none',
                paddingRight: 0, textAlign: 'center', width: 'fit-content',
                borderRadius: 0,

              }}
                title={
                  <span >

                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#777677" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539a7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539a7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" /></svg>&nbsp;{currentLang}
                  </span>
                }
                id="nav-language-dropdown"
                align="end"
              >
                {languages.map((lng) => (
                  <NavDropdown.Item
                    key={lng}
                    onClick={() => changeLanguage(lng)}
                    active={currentLang === lng} // Highlights selected one
                  >
                    {languageLabels[lng]}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            </div>
          </div>
        </div>
      </div>

    

    </header >
    {/* {logoutConfirm && (
          <LogoutConfirmPopup
  show={logoutConfirm}
  onHide={() => setLogoutConfirm(false)}
  onLogout={handleLogout}
/>
        )} */}
  </>
  );
};

export default Header;